import React, { useContext, useEffect, useMemo, useState } from "react";
import CheckListFBYInput from "../../../../../../blocks/FormItems/CheckListFBYInput";
import { Typography } from "antd";
import { heartSoundsOptions } from "../../../../Options/systemicExamOptions";
const { Text } = Typography;

const HeartSounds = ({ context, form }) => {
  const { formData } = useContext(context);
  const heartSoundData = formData?.systemic_examination || formData;
  const initialValues = useMemo(() => heartSoundData, [formData]);
  const [checkboxes, setCheckboxes] = useState([]);

  useEffect(() => {
    const initialCheckboxes = heartSoundsOptions.reduce((acc, checkbox) => {
      const val = initialValues?.[checkbox.value];
      acc[checkbox.value] = val ?? ["s1", "s2"].includes(checkbox.value);
      return acc;
    }, {});

    // 👇 update Ant Design Form values
    const initialFormValues = {};
    Object.keys(initialCheckboxes).forEach((key) => {
      initialFormValues[key] = initialCheckboxes[key];
    });
    form.setFieldsValue(initialFormValues);

    setCheckboxes(initialCheckboxes);
  }, [initialValues, form]);

  return (
    <>
      <Text>Heart Sounds</Text>
      <CheckListFBYInput
        options={heartSoundsOptions}
        checkboxes={checkboxes}
        setCheckboxes={setCheckboxes}
        form={form}
      />
    </>
  );
};

export default HeartSounds;
